import React from 'react';

/**
 * Componente de logotipo de la aplicación.
 * Renderiza el logo SVG con soporte para diferentes tamaños y variantes de color.
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.size='medium'] - Tamaño: 'small' | 'medium' | 'large'
 * @param {string} [props.variant='default'] - Variante de color: 'default' | 'white' | 'dark'
 * @param {string} [props.className=''] - Clases CSS adicionales para el contenedor
 * @param {boolean} [props.showText=false] - (No implementado) Reservado para mostrar texto
 * @param {Function} [props.onClick=null] - Handler de click, si se proporciona el logo es clickeable
 * @returns {JSX.Element}
 */
function Logo({
  size = 'medium',
  variant = 'default',
  className = '',
  showText = false,
  onClick = null
}) {
  const variantClasses = {
    default: '',
    white: 'logo-white',
    dark: 'logo-dark'
  };

  const containerClasses = [
    'logo-container',
    `logo-container-${size}`,
    onClick ? 'logo-container-clickable' : '',
    className
  ].filter(Boolean).join(' ');

  const logoClasses = [
    'logo',
    `logo-${size}`,
    variantClasses[variant]
  ].filter(Boolean).join(' ');

  return (
    <div
      className={containerClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <img
        src="/img/DESMAQ.svg"
        alt="DESMAQ"
        className={logoClasses}
      />
    </div>
  );
}

export default Logo;
